import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../configurations/axiosInstance/AxiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMedkit,
    faMapMarkerAlt,
    faPhone,
    faBuilding,
    faBed,
    faRuler,
    faHospital,
    faRoute,
    faGlobe
} from "@fortawesome/free-solid-svg-icons";
import { LoadingContext } from "../../composants/loadingContext";
import Loader from "../../composants/loader/Loader";


function Usraj() {
    const { id } = useParams();
    const { loading, setLoading } = useContext(LoadingContext);
    const [usraj, setUsraj] = useState([]);
    const [userLocalusation, setUserLocalusation] = useState(null);

    const fetchUsraj = () => {
        setLoading(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                setUserLocalusation({
                    latitude: latitude,
                    longitude: longitude
                });
                axiosInstance().get('public/api/centrepartenaire/getById/' + id)
                    .then(function (response) {
                        let data = [];
                        data.push(response.data);
                        if ((data == null) || (data.length === 0)) {
                            setUsraj([])
                        } else {
                            setUsraj(data);
                        }
                        setLoading(false);
                    })
                    .catch(function (error) {
                        setUsraj([]);
                        setLoading(false);
                        console.error('Error fetching USRAJ:', error);
                    });
            }, function (error) {
                setLoading(false);
                toast.error("Erreur lors de la récupération de la position.");
            });
        } else {
            setLoading(false);
            toast.error("La géolocalisation n'est pas supportée par ce navigateur.");
        }
    };

    useEffect(
        () => {
            document.title = 'USRAJ - Détails';
            fetchUsraj();
        }, []
    );

    const calculateDistance = (userLat, userLon, cpLat, cpLon) => {
        const R = 6371; // Rayon de la Terre en kilomètres
        const latDistance = toRadians(cpLat - userLat);
        const lonDistance = toRadians(cpLon - userLon);

        const a = Math.sin(latDistance / 2) * Math.sin(latDistance / 2) +
            Math.cos(toRadians(userLat)) * Math.cos(toRadians(cpLat)) *
            Math.sin(lonDistance / 2) * Math.sin(lonDistance / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    const toRadians = (degrees) => {
        return degrees * (Math.PI / 180);
    }

    return (
        <>
            {loading && <Loader />}

            {usraj.length === 0 ? (
                <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center py-20">
                    <div className="text-center max-w-md mx-auto px-4">
                        <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-green-100 to-teal-100 rounded-full mb-6">
                            <FontAwesomeIcon icon={faHospital} className="text-5xl text-green-500" />
                        </div>
                        <h3 className="text-2xl font-bold text-gray-800 mb-3">
                            Centre non trouvé
                        </h3>
                        <p className="text-gray-600">
                            Impossible de charger les informations de ce centre de santé.
                        </p>
                    </div>
                </div>
            ) : (
                usraj.map((value) => {
                    const distance = userLocalusation ? calculateDistance(
                        userLocalusation.latitude,
                        userLocalusation.longitude,
                        value.latittude,
                        value.longitude
                    ) : 0;

                    return (
                        <div key={value.id}>
                            {/* Hero Section with Image */}
                            <div className="relative h-96 overflow-hidden bg-gradient-to-br from-green-600 via-teal-500 to-blue-600">
                                {/* Background Image with Overlay */}
                                <div className="absolute inset-0">
                                    <img
                                        src={value.photo?.includes('null') ? '/images/image.png' : value.photo}
                                        alt={value.nom}
                                        className="w-full h-full object-cover"
                                        onError={(e) => {
                                            e.target.src = '/images/image.png';
                                        }}
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                                </div>

                                {/* Content */}
                                <div className="relative h-full flex items-end">
                                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 w-full">
                                        <div className="flex items-end justify-between flex-wrap gap-4">
                                            <div>
                                                <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-4">
                                                    <FontAwesomeIcon icon={faHospital} className="text-white" />
                                                    <span className="text-white font-medium">{value.category}</span>
                                                </div>
                                                <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-3 tracking-tight">
                                                    {value.nom}
                                                </h1>
                                                <p className="text-white/90 text-lg max-w-2xl">
                                                    Unité de Santé de Reproduction Ados Jeunes
                                                </p>
                                            </div>

                                            {userLocalusation && (
                                                <div className="bg-white/10 backdrop-blur-sm px-6 py-4 rounded-2xl border border-white/20">
                                                    <div className="flex items-center gap-3">
                                                        <FontAwesomeIcon icon={faRoute} className="text-2xl text-white" />
                                                        <div>
                                                            <p className="text-white/70 text-sm">Distance</p>
                                                            <p className="text-white text-2xl font-bold">
                                                                {Math.round(distance * 100) / 100} km
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Main Content */}
                            <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12">
                                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                                        {/* Left Column - Contact & Location */}
                                        <div className="lg:col-span-1 space-y-6">
                                            {/* Contact Card */}
                                            <div className="bg-white rounded-2xl shadow-lg p-6">
                                                <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                                                    <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
                                                        <FontAwesomeIcon icon={faPhone} className="text-white" />
                                                    </div>
                                                    Contact
                                                </h2>

                                                <div className="space-y-4">
                                                    <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                                        <FontAwesomeIcon icon={faPhone} className="text-blue-500 mt-1" />
                                                        <div>
                                                            <p className="text-xs text-gray-500 mb-1">Téléphone</p>
                                                            <p className="text-sm font-semibold text-gray-800">
                                                                {value.telephone || 'Non disponible'}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="text-purple-500 mt-1" />
                                                        <div>
                                                            <p className="text-xs text-gray-500 mb-1">Adresse</p>
                                                            <p className="text-sm font-semibold text-gray-800">
                                                                {value.address || 'Non disponible'}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div className="flex items-start gap-3 p-4 bg-gradient-to-r from-blue-50 to-teal-50 rounded-xl border border-blue-100">
                                                        <FontAwesomeIcon icon={faGlobe} className="text-teal-500 mt-1" />
                                                        <div className="flex-1">
                                                            <p className="text-xs text-gray-500 mb-1">Coordonnées GPS</p>
                                                            <p className="text-sm font-mono text-gray-800 break-all">
                                                                {value.latittude}, {value.longitude}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Right Column - Details & Services */}
                                        <div className="lg:col-span-2 space-y-6">
                                            {/* Infrastructure Card */}
                                            <div className="bg-white rounded-2xl shadow-lg p-6">
                                                <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                                                    <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-teal-500 rounded-lg flex items-center justify-center">
                                                        <FontAwesomeIcon icon={faBuilding} className="text-white" />
                                                    </div>
                                                    Infrastructure
                                                </h2>

                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                                        <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faRuler} className="text-white text-sm" />
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-gray-500 font-medium mb-1">Superficie</p>
                                                            <p className="text-lg font-bold text-gray-800">{value.superficie} km²</p>
                                                        </div>
                                                    </div>

                                                    <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                                        <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faBuilding} className="text-white text-sm" />
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-gray-500 font-medium mb-1">Bâtiments</p>
                                                            <p className="text-lg font-bold text-gray-800">{value.nombreBat}</p>
                                                        </div>
                                                    </div>

                                                    <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                                        <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-pink-500 to-pink-600 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faBed} className="text-white text-sm" />
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-gray-500 font-medium mb-1">Lits disponibles</p>
                                                            <p className="text-lg font-bold text-gray-800">{value.nombreLit}</p>
                                                        </div>
                                                    </div>

                                                    <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                                        <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-gray-500 to-gray-600 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faHospital} className="text-white text-sm" />
                                                        </div>
                                                        <div>
                                                            <p className="text-xs text-gray-500 font-medium mb-1">Morgue</p>
                                                            <p className="text-lg font-bold text-gray-800">
                                                                {value.morgue ? 'Disponible' : 'Non disponible'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Services Card */}
                                            {value.serviceOfferts && value.serviceOfferts.length > 0 && (
                                                <div className="bg-white rounded-2xl shadow-lg p-6">
                                                    <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                                                        <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-teal-500 rounded-lg flex items-center justify-center">
                                                            <FontAwesomeIcon icon={faMedkit} className="text-white" />
                                                        </div>
                                                        Services Offerts
                                                        <span className="ml-auto text-sm font-normal bg-gradient-to-r from-green-100 to-teal-100 text-green-700 px-3 py-1 rounded-full">
                                                            {value.serviceOfferts.length} service{value.serviceOfferts.length > 1 ? 's' : ''}
                                                        </span>
                                                    </h2>

                                                    <div className="grid grid-cols-1 gap-6">
                                                        {value.serviceOfferts.map((service, index) => (
                                                            <div
                                                                key={service.id}
                                                                className="flex flex-col p-5 bg-gradient-to-br from-green-50 to-white rounded-xl border border-green-100 hover:shadow-md transition-all duration-300"
                                                                style={{
                                                                    animation: `fadeInUp 0.5s ease-out ${index * 0.05}s both`
                                                                }}
                                                            >
                                                                <div className="flex items-center gap-3 mb-4">
                                                                    <div className="flex-shrink-0 w-3 h-3 bg-gradient-to-r from-green-500 to-teal-500 rounded-full"></div>
                                                                    <span className="text-lg font-bold text-gray-800">
                                                                        {service.libelle}
                                                                    </span>
                                                                </div>

                                                                {service.produits && service.produits.length > 0 ? (
                                                                    <div className="space-y-3 pl-6">
                                                                        {service.produits.map((produit) => (
                                                                            <div key={produit.id} className="flex justify-between items-center bg-white p-3 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                                                                                <div className="flex flex-col pr-4">
                                                                                    <span className="text-sm font-bold text-gray-700">{produit.libelle}</span>
                                                                                    {produit.description && <span className="text-xs text-gray-500 mt-1 line-clamp-2">{produit.description}</span>}
                                                                                </div>
                                                                                <div className="flex-shrink-0">
                                                                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold bg-green-100 text-green-800">
                                                                                        {produit.prix > 0 ? `${produit.prix} FCFA` : 'Gratuit'}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                ) : (
                                                                    <div className="pl-6 text-sm text-gray-500 italic bg-white/50 p-3 rounded-lg border border-dashed border-gray-200">
                                                                        Aucun produit disponible pour ce service.
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })
            )}

            <style>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </>
    );

}

export default Usraj;